import Button from '@rio-cloud/rio-uikit/Button';

import { CustomFormattedMessage } from '../../../../i18n/i18n';
import {
  DialogMode,
  openConfigurationDialog,
} from '../../state/onboardingUiSlice';
import classNames from 'classnames';
import { useServiceConfigurationFormContext } from './serviceConfigurationDialog/ServiceConfigurationForm';
import { PaymentMethodState } from '../../../../codegen/vehicles';
import { useDispatch } from 'react-redux';

type DialogFooterProps = {
  onClose: () => void;
  onSave: () => void;
  dialogMode: DialogMode;
  isSaveButtonEnabled: boolean;
  showLegalText: boolean;
  isLoading: boolean;
};

const CloseButton = ({
  onClick,
  isDisabled,
}: {
  onClick: () => void;
  isDisabled: boolean;
}) => (
  <Button
    bsStyle={'default'}
    type={'button'}
    className={'margin-right-10'}
    onClick={onClick}
    disabled={isDisabled}
  >
    <CustomFormattedMessage id={'common.action.close'} />
  </Button>
);

const CancelButton = ({
  onClick,
  isDisabled,
}: {
  onClick: () => void;
  isDisabled: boolean;
}) => (
  <Button
    bsStyle={'default'}
    type={'button'}
    className={'margin-right-10'}
    onClick={onClick}
    disabled={isDisabled}
  >
    <CustomFormattedMessage id={'common.action.cancel'} />
  </Button>
);

const SaveButton = ({
  onClick,
  isLoading,
  isDisabled,
}: {
  onClick: () => void;
  isLoading: boolean;
  isDisabled: boolean;
}) => (
  <Button
    bsStyle={'primary'}
    type={'submit'}
    className={classNames({
      'btn-loading': isLoading,
    })}
    onClick={onClick}
    disabled={isDisabled}
  >
    <CustomFormattedMessage id={'common.action.save'} />
  </Button>
);

const ManageServicesButton = () => {
  const dispatch = useDispatch();
  const formContext = useServiceConfigurationFormContext();
  const formData = formContext.watch();
  const paymentMethod = formData.paymentMethods[0];

  if (!paymentMethod) return null;

  return (
    <Button
      data-testid={'dialog-footer-manage-services-button'}
      bsStyle={'primary'}
      type={'button'}
      onClick={() => {
        dispatch(openConfigurationDialog(DialogMode.SERVICES));
      }}
      disabled={paymentMethod.state !== PaymentMethodState.Active}
    >
      <CustomFormattedMessage
        id={'onboarding.dialog.firstCard.manageServicesButton'}
      />
    </Button>
  );
};

export const DialogFooter = ({
  isSaveButtonEnabled,
  showLegalText,
  dialogMode,
  isLoading,
  onClose,
  onSave,
}: DialogFooterProps) => {
  switch (dialogMode) {
    case DialogMode.SERVICES:
      return (
        <>
          {showLegalText && (
            <div
              data-testid={'transactions-sidebar-amounts'}
              className="margin-bottom-20"
            >
              <CustomFormattedMessage id={'onboarding.dialog.services.legal'} />
            </div>
          )}
          <CancelButton
            onClick={onClose}
            isDisabled={isLoading}
          />
          <SaveButton
            onClick={onSave}
            isLoading={isLoading}
            isDisabled={!isSaveButtonEnabled || isLoading}
          />
        </>
      );
    case DialogMode.SERVICE_CARDS:
      return (
        <CloseButton
          onClick={onClose}
          isDisabled={isLoading}
        />
      );
    case DialogMode.FIRST_SERVICE_CARD:
      return (
        <>
          <CloseButton
            onClick={onClose}
            isDisabled={isLoading}
          />
          <ManageServicesButton />
        </>
      );
  }
};
